(() => {
  if (customElements.get("information-table")) {
    return;
  }

  class InformationTable extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        wrapper: "[data-wrapper]",
        featuredRow: "[data-featured-row]",
        rowContent: "[data-row-content]",
        slider: "[data-slider]",
        pagination: "[data-pagination]",
      };
      this.slider = this.querySelector(this.selectors.slider);
      this.options = {
        pagination: {
          el: this.closest(this.selectors.wrapper).querySelector(
            this.selectors.pagination
          ),
          type: "bullets",
          clickable: true,
        },
        spaceBetween: 8,
        slidesPerView: 1,
        breakpoints: {
          750: {
            slidesPerView: 2,
          },
          990: {
            spaceBetween: 16,
            slidesPerView: 3,
          },
        },
      };
    }

    connectedCallback() {
      ["load", "resize", "shopify:section:load"].forEach((eventName) => {
        window.addEventListener(
          eventName,
          this.debounce((event) => {
            this.setupHeightVariables();
          }, 300).bind(this)
        );
      });

      this.initSlider();
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    initSlider() {
      if (!this.slider) return;
      this.slider = new Swiper(this.slider, this.options);
    }

    setupHeightVariables() {
      this.removeAttribute("style");
      let featuredRowHeight = 0;
      [...this.querySelectorAll(this.selectors.featuredRow)].map(
        (featuredRow) => {
          featuredRowHeight = this.getNewRowHeight(
            featuredRowHeight,
            this.getHeightValue(featuredRow)
          );
        }
      );
      this.style.setProperty(
        "--featured-row-height",
        `${featuredRowHeight * 0.1}rem`
      );

      for (let i = 0; i <= 7; i++) {
        let rowHeight = 0;
        [
          ...this.querySelectorAll(
            `${this.selectors.rowContent}[data-index="${i}"]`
          ),
        ].forEach((rowContent) => {
          if (!rowContent) return;
          rowHeight = this.getNewRowHeight(
            rowHeight,
            this.getHeightValue(rowContent)
          );
        });

        this.style.setProperty(
          `--min-row-height-${i}`,
          `${rowHeight * 0.1}rem`
        );
      }
    }

    getHeightValue(element) {
      return Number(
        window
          .getComputedStyle(element)
          .getPropertyValue("height")
          .replace(/px$/, "")
      );
    }

    getNewRowHeight(currentRowHeight, compareRowHeight) {
      if (compareRowHeight < currentRowHeight) return currentRowHeight;
      return compareRowHeight;
    }
  }

  customElements.define("information-table", InformationTable);
})();
